module.exports = __webpack_public_path__ + "static/media/sc8.94d7e17b.jpg";